<template>
  <div>
    <!-- Confirmation Prompt -->
    <vs-prompt
      :title="$t('orgDashboard.talentPool.deactivateUserTitle')"
      @accept="deactivateUser"
      :accept-text="$t('orgDashboard.talentPool.confirm')"
      :active.sync="confirmUserDeactivation"
    >
      <div>
        {{ $t('orgDashboard.talentPool.areYouSure') }}
        <b>{{ firstName }}</b>
        {{ $t('orgDashboard.talentPool.fromThisOrganization') }}
      </div>
    </vs-prompt>

    <!-- Tooltip Wrapper -->
    <vs-tooltip :text="$t('orgDashboard.talentPool.deactivate_user')" position="top">

      <vs-button
  class="delete-btn"
  @click.stop="confirmUserDeactivation = true"
  :disabled="deactivationInProgress"
>

  <vs-icon
    icon="delete"
    size="16px"
    class="delete-icon"
  />

</vs-button>

    </vs-tooltip>

    <!-- Progress text -->
    <span v-if="deactivationInProgress" style="color: red; font-size: 10px;">
      {{ $t('orgDashboard.talentPool.deactivationInProgress') }}
    </span>

  </div>
</template>

<script>
export default {
  props: ["firstName", "employeeId"],

  data() {
    return {
      confirmUserDeactivation: false,
      deactivationInProgress: false,
    };
  },

  // No computed properties needed

  methods: {

    async deactivateUser() {
      this.deactivationInProgress = true;
      try {
        await this.$store.dispatch("organization/deactivateEmployee", {
          employeeId: this.employeeId,
        });
        this.confirmUserDeactivation = false;
      } catch (error) {
        // Optionally, show an error notification here
        // this.$notify({ type: 'error', message: this.$t('orgDashboard.userActions.deactivationFailed') });
      } finally {
        this.deactivationInProgress = false;
      }
    },

  },

};
</script>
<style scoped>

.delete-btn {

  background: transparent !important;
  border: none !important;

  width: 32px;
  height: 32px;

  border-radius: 50% !important;

  display: inline-flex !important;
  align-items: center;
  justify-content: center;

  padding: 0 !important;

  transition: background 0.25s ease;

}

.delete-icon {

  color: #EA5455 !important;
  font-size: 18px;
  transition: color 0.25s ease;

}


/* HOVER → ROUND RED CIRCLE */

.delete-btn:hover {

  background: #EA5455 !important;

}

.delete-btn:hover .delete-icon {

  color: #ffffff !important;

}

</style>